import { Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer"
import PropTypes from "prop-types"

const styles = StyleSheet.create({
  page: {
    padding: 36,
  },
  description: {
    marginTop: 8,
    marginBottom: 8,
  },
  table: {
    marginTop: 16,
  },
  rowTable: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid #000",
    borderBottom: 0,
  },
  colTable: {
    padding: 4,
    paddingLeft: 8,
    display: "flex",
    width: "10%",
    textAlign: "left",
    borderRight: "1px solid #000",
  },
  title: {
    color: "#000",
    textTransform: "uppercase",
    fontSize: 18,
    marginBottom: 8,
  },
  body1: {
    color: "#000",
    fontSize: 16,
    marginTop: 2,
    marginBottom: 2,
  },
  body2: {
    color: "#505050",
    textTransform: "uppercase",
    fontSize: 14,
    marginTop: 2,
    marginBottom: 2,
  },
  paragraph: {
    color: "#000",
    fontSize: 12,
    marginTop: 2,
    marginBottom: 2,
  },
  caption: {
    color: "#000",
    fontSize: 10,
    marginTop: 2,
    marginBottom: 2,
  },
  endRowBorder: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid #000",
  },
  pageNumbers: {
    position: "absolute",
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 10,
  },
})

export function VoucherDocument({ dataDocument, companyName, account, creationDate }) {
  // Style the last item
  const styleLastItem = (documentItem) => {
    const indexOfDocumentItem = dataDocument.indexOf(documentItem)
    const indexOfLastItem = dataDocument.length - 1
    if (indexOfLastItem === indexOfDocumentItem) return true
    return false
  }

  // Calculate total price
  const totalPrice = () => {
    const total = dataDocument.reduce((accumulator, packageItem) => accumulator + packageItem.packagePrice, 0)
    return (total || 0).toFixed(2)
  }

  return (
    <Document title="Bon de sortie" language="en" subject="Exit voucher for selected packages">
      <Page size="A4" style={styles.page}>
        <View>
          <Text style={styles.title}>BON DE SORTIE</Text>
        </View>
        <View style={styles.description}>
          <Text style={styles.body2}>Informations pick-up</Text>
          <Text style={styles.paragraph}>Date: {creationDate}</Text>
          <Text style={styles.paragraph}>Client: {account}</Text>
          <Text style={styles.paragraph}>Société de livraison: {companyName}</Text>
          <Text style={styles.paragraph}>Nombre de colis: {dataDocument.length}</Text>
          <Text style={styles.paragraph}>Total: {totalPrice()} TND</Text>
        </View>
        <View style={styles.table}>
          <View style={styles.rowTable}>
            <View
              style={{
                ...styles.colTable,
                width: "20%",
              }}
            >
              <Text style={styles.caption}>Code à barre</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "15%",
              }}
            >
              <Text style={styles.caption}>Client</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "15%",
              }}
            >
              <Text style={styles.caption}>Téléphone</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "25%",
              }}
            >
              <Text style={styles.caption}>Designation</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "15%",
              }}
            >
              <Text style={styles.caption}>Governorat</Text>
            </View>
            <View
              style={{
                ...styles.colTable,
                width: "10%",
                border: 0,
              }}
            >
              <Text style={styles.caption}>Montant</Text>
            </View>
          </View>
          {/* Row 1 */}
          {dataDocument.map((documentItem) => (
            <View
              style={styleLastItem(documentItem) ? styles.endRowBorder : styles.rowTable}
              key={documentItem.barcode}
            >
              <View
                style={{
                  ...styles.colTable,
                  width: "20%",
                }}
              >
                <Text style={styles.paragraph}>{documentItem.barcode}</Text>
              </View>
              <View
                style={{
                  ...styles.colTable,
                  width: "15%",
                }}
              >
                <Text style={styles.paragraph}>{documentItem.clientName}</Text>
              </View>
              <View
                style={{
                  ...styles.colTable,
                  width: "15%",
                }}
              >
                <Text style={styles.paragraph}>{documentItem.clientPhoneNumber}</Text>
              </View>
              <View
                style={{
                  ...styles.colTable,
                  width: "25%",
                }}
              >
                <Text style={styles.paragraph}>{documentItem.description}</Text>
              </View>
              <View
                style={{
                  ...styles.colTable,
                  width: "15%",
                }}
              >
                <Text style={styles.paragraph}>{documentItem.state}</Text>
              </View>
              <View
                style={{
                  ...styles.colTable,
                  width: "10%",
                  border: 0,
                }}
              >
                <Text style={styles.paragraph}>{(documentItem.packagePrice || 0).toFixed(2)}</Text>
              </View>
            </View>
          ))}
        </View>

        <Text
          style={styles.pageNumbers}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        />
      </Page>
    </Document>
  )
}

// Typechecking props of the PackageDocument
VoucherDocument.propTypes = {
  dataDocument: PropTypes.arrayOf(
    PropTypes.shape({
      barcode: PropTypes.string.isRequired,
      clientName: PropTypes.string.isRequired,
      clientPhoneNumber: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      packagePrice: PropTypes.number.isRequired,
      state: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  creationDate: PropTypes.string.isRequired,
}
